var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',_vm._l((_vm.histories),function(h){return _c('history-card',{key:h.id,attrs:{"history":h}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }